/* eslint-disable no-console */
import { useState, useEffect } from 'react';
import { restService } from 'utilities';
import useRefresh from './useRefresh';

export const useRewardData = (address, refresh) => {
  const numberFormat = Intl.NumberFormat('en-US');

  const { slowRefresh } = useRefresh();
  const [stakingPoint, setStakingPoint] = useState(0);
  const [estimatedReward, setEstimatedReward] = useState(0);
  const [totalReserve, setTotalReserve] = useState(0);
  const [reserveApy, setReserveApy] = useState(0);
  const [reservePrimeApy, setReservePrimeApy] = useState(0);
  const [claimableReward, setClaimableReward] = useState(0);

  useEffect(() => {
    const fetchRewardData = async () => {
      try {
        const data = await restService({
          api: '/prime',
          method: 'GET',
          params: {}
        });

        // Check if data and nested properties exist
        if (data && data.data && data.data.data) {
          setTotalReserve(data.data.data.totalReservesUsd);

          if (Number(data.data.data.totalLockedUsd) > 0) {
            setReserveApy(
              ((Number(data.data.data.totalReservesUsd) * 12 * 100) /
                Number(data.data.data.totalLockedUsd) +
                Number(data.data.data.baseApr) * 100) *
                2
            );

            setReservePrimeApy(
              (Number(data.data.data.totalReservesUsd) * 12 * 100) /
                Number(data.data.data.totalLockedUsd)
            );
          } else setReserveApy(Number(data.data.data.baseApr) * 100 * 2);
        } else {
          console.warn('Prime API response is invalid or empty:', data);
        }

        if (address) {
          try {
            const scoreData = await restService({
              api: `/prime/score?address=${address}`,
              method: 'GET',
              params: {}
            });

            // Check if scoreData and nested properties exist
            if (scoreData && scoreData.data && scoreData.data.data) {
              setStakingPoint(
                Number(scoreData.data.data.pending.userScore) * 1000000
              );

              if (scoreData.data.data.pending.totalScore > 0)
                setEstimatedReward(
                  (Number(scoreData.data.data.pending.totalReward) *
                    Number(scoreData.data.data.pending.userScore)) /
                    Number(scoreData.data.data.pending.totalScore)
                );

              setClaimableReward(Number(scoreData.data.data.claimableAmount));
            } else {
              console.warn(
                'Score API response is invalid or empty:',
                scoreData
              );
            }
          } catch (scoreError) {
            console.warn('Failed to fetch score data:', scoreError);
          }
        }
      } catch (error) {
        console.warn('Failed to fetch reward data:', error);
        // Set default values when API fails
        setTotalReserve(0);
        setReserveApy(0);
        setReservePrimeApy(0);
      }
    };

    fetchRewardData();
  }, [slowRefresh, address, refresh]);

  return {
    stakingPoint: stakingPoint.toFixed(2),
    estimatedReward: numberFormat.format(estimatedReward),
    claimableReward: numberFormat.format(claimableReward),
    totalReserveReward: numberFormat.format(totalReserve),
    reserveApy: reserveApy.toFixed(1),
    reservePrimeApy: reservePrimeApy.toFixed(1)
  };
};
